import React from "react";
import styles from "./FJStockListTitle.module.less";
import FJUtil from "../../../../util/FJUtil";

function FJStockListTitle(props) {
	const {total, keywords, type} = props;
	return (
		<div className={styles.title}>
			<span className={styles.title_normal}>{FJUtil.formatNumber(total)}</span>
			<span className={styles.keyword_title}>{keywords}</span>
			<span className={styles.title_normal}>{type}</span>
		</div>
	)

}


export default FJStockListTitle;